/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgChartStackedBar = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M5.5 10h3v9.5h-3zM7 4.5h1.5v4h-3v-4zM15.5 16h3v3.5h-3zm-5-3h3v6.5h-3zM12 8.5h1.5v3h-3v-3zm6.5 6h-3v-2h3z" /></svg>;
export default SvgChartStackedBar;